document.addEventListener("DOMContentLoaded", function() {
  const items = document.querySelectorAll('.auto_scroll .slider__item');
  let currentIndex = 0;
  let intervalId = null;

  function startAnimation() {
    if (window.innerWidth <= 1024) {
      intervalId = setInterval(showNextItem, 3000);
      showNextItem();
    }
  }

  function stopAnimation() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    items.forEach(item => {
      item.style.opacity = '1';
      item.style.visibility = 'visible';
    });
  }

  function showNextItem() {
    items.forEach(item => {
      item.style.opacity = '0';
      item.style.visibility = 'hidden';
    });
    items[currentIndex].style.opacity = '1';
    items[currentIndex].style.visibility = 'visible';
    currentIndex = (currentIndex + 1) % items.length;
  }

  startAnimation();

  window.addEventListener('resize', function() {
    if (window.innerWidth <= 1024) {
      if (!intervalId) startAnimation();
    } else {
      stopAnimation();
    }
  });
});
